import { restoreValue, persistValue } from "../utils/local_storage_form";

const KEY_NAME = "spot_comment_author_name";
const KEY_EMAIL = "spot_comment_author_email";

document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("spot-comment-form");
  if (!form) return;

  const nameInput = document.getElementById("spot-comment-author-name");
  const emailInput = document.getElementById("spot-comment-author-email");

  restoreValue(nameInput, KEY_NAME);
  restoreValue(emailInput, KEY_EMAIL);

  persistValue(nameInput, KEY_NAME);
  persistValue(emailInput, KEY_EMAIL);
});
